import { render, staticRenderFns } from "./DiscountModule.vue?vue&type=template&id=04278f37&scoped=true"
import script from "./DiscountModule.vue?vue&type=script&lang=js"
export * from "./DiscountModule.vue?vue&type=script&lang=js"
import style0 from "./DiscountModule.vue?vue&type=style&index=0&id=04278f37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04278f37",
  null
  
)

export default component.exports